import { CommandScenario } from "./command-scenario.enum";

/**
 * This interface defines information that a command knows
 * about the {@link CommandEvent} which triggerd it.
 *
 * It holds information that help identify the event, identify
 * any other events that it affects and information about
 * scenario it was executed in.
 *
 * @since   2018-08-22
 * @author  Ramishka
 */
export interface ICommandEventData {
    /**
     * A unique id that is used to identify the event
     */
    eventId: string;

    /**
     * Name of the command event.
     */
    eventName: string;

    /**
     * event source, user triggered or system event
     */
    source?: string;

    /**
     * If this event is based on another event (i.e. an event
     * that undones another event), that events id is specified here.
     */
    originalEventId?: string;

    /**
     * The command scenario this event is being executed under
     */
    scenario?: CommandScenario;

    /**
     * Context data assciated with the command,
     * e.g. When a edata change is dispatched we can set the diagramId in the context
     * ctx = { diagramId: 'd1' }
     */
    changeCtx?: any;

    /**
     * Context data assciated with the command,
     * e.g. When a edata change is dispatched we can set the diagramId in the context
     * ctx = { diagramId: 'd1' }
     */
    ctx?: any;
}

/**
 * EventSource = 'user' means user triggered events
 * EventSource = 'system' means system triggered events in response to user interaction
 * EventSource = 'external' means events that will fire from listeners in response to external event,
 *                          these events are not tracked in session history.
 * EventSource = 'transient' means events is temporary and will be confirmed by next event.
 *                         these events are undone automatically if the next event is undone by user.
 */
export enum EventSource {
    USER = 'user',
    SYSTEM = 'system',
    EXTERNAL = 'external',
    TRANSIENT = 'transient',
}
